import api from '../api/axios';

export type LoginRequest = {
  email: string;
  password: string;
};

export type RegisterRequest = {
  name: string;
  email: string;
  password: string;
  platform?: string; // default 'web' if not provided
};

export type UserDTO = {
  id: string;
  name: string;
  email: string;
  platform: string;
  createdAt: string;
  avatarUrl?: string;
  avatar?: string;
  role?: 'ADMIN' | 'MEMBER' | 'MANAGER' | string;
};

export type LoginResponse = {
  token: string;
  expiresIn: number;
  user: UserDTO;
};

export type UpdateProfileRequest = {
  name: string;
  avatar?: string;
};

const BASE = process.env.REACT_APP_BASE_API_URL || process.env.REACT_APP_API_URL || '';

const withBase = (path: string) => `${BASE}${path}`;

const login = async (payload: LoginRequest) => {
  const res = await api.post(withBase('/auth/login'), payload);
  return res.data as LoginResponse;
};

const register = async (payload: RegisterRequest) => {
  const body = { platform: 'web', ...payload };
  const res = await api.post(withBase('/auth/register'), body);
  return res.data as { id?: string } | any;
};

const updateProfile = async (id: string, payload: UpdateProfileRequest) => {
  const res = await api.patch(withBase(`/members/${id}`), payload);
  return res.data as UserDTO;
};

const authService = {
  login,
  register,
  updateProfile,
};

export default authService;
